import type { ComponentProps } from 'react'
import { ÅBg, type ÅBgProps } from '@/components/å/bg'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ÅButtonProps extends ComponentProps<typeof Button> {
  bg?: ÅBgProps
}

function AppButton({ className, children, bg, ...props }: ÅButtonProps) {
  return (
    <Button className={cn('app-button', className)} {...props}>
      <ÅBg {...bg} className={cn('app-button-bg', bg?.className)} />
      <span className="relative inline-flex items-center gap-1">
        {children}
      </span>
    </Button>
  )
}

export { AppButton as ÅButton }
export type { ÅButtonProps }
